document.addEventListener("click", function (event) {
  const dropdowns = document.querySelectorAll(".merch-filter");

  dropdowns.forEach(function (dropdown) {
    const isOpen = dropdown.classList.contains("open");
    const clickedFilter = event.target.closest(".merch-filter");

    if (clickedFilter !== dropdown) {
      dropdown.classList.remove("open");
    }

    if (clickedFilter === dropdown && !isOpen) {
      dropdown.classList.add("open");
    } else if (clickedFilter === dropdown && isOpen) {
      dropdown.classList.remove("open");
    }
  });
});

function assignFilter(filterName) {
  const filterOptions = document.querySelectorAll(`.${filterName}`);
  const currentUrl = new URL(window.location.href);

  filterOptions.forEach(function (filter) {
    filter.addEventListener("click", function (event) {
      event.preventDefault();
      const filterType = filter.dataset.filter;
      const filterTitle = filter.innerText;

      if (filterName.includes("merch-sort")) {
        localStorage.setItem("selectedSort", filterTitle);
        currentUrl.searchParams.set("sort_by", filterType);
        window.location.href = currentUrl.toString();
      } else if (filterName.includes("merch-filter")) {
        localStorage.setItem("selectedFilter", filterTitle);
        currentUrl.searchParams.set("filter.p.product_type", filterType);
        window.location.href = currentUrl.toString();
      }
    });
  });

  if (currentUrl.searchParams.get("filter.p.product_type")) {
    document.querySelector(".merch-filter__selected-option").innerText =
      localStorage?.getItem("selectedFilter")?.replace("-", " ") ||
      "All Products";
  }
  if (currentUrl.searchParams.get("sort_by")) {
    document.querySelector(".merch-sort__selected-option").innerText =
      localStorage?.getItem("selectedSort")?.replace("-", " ") ||
      "Best Selling";
  }
}

assignFilter("merch-filter__option");
assignFilter("merch-sort__option");
